import React from 'react'
import DeleteIcon from "@material-ui/icons/Delete";
import {
    TablePagination,
    Table,
    TableRow,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    Box,
    makeStyles,
    Typography,
    ButtonGroup,
    InputBase,
    withStyles,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Grid,
    TextField


} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete'
import { FetchCoachSearchList, FetchJobSeekerCoach } from "../apis";
import { shallowEqual, useSelector } from "react-redux";
const useStyles = makeStyles((theme) => ({
    root: {
        position: "relative",
    },
    table: {
        minWidth: 1050,
    },
    tableHeadCell: {
        fontSize: "18px",
    },
    tableRowCell: {
        fontSize: "14px",
        borderBottom: "none",
        lineHeight: "40px",
        align: "left",
    },
    dropdown: {
        position: "absolute",
        top: 28,
        right: 0,
        left: 0,
        zIndex: 1,
        border: "1px solid",
        padding: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,
    },
    search: {
        position: "relative",
        borderRadius: theme.shape.borderRadius,
        backgroundColor: "#f2f2f2",
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: "100%",
        [theme.breakpoints.up("sm")]: {
            marginLeft: theme.spacing(3),
            width: "auto",
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: "100%",
        position: "absolute",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    inputRoot: {
        color: "inherit",
        fontSize: "14px",
    },
    inputInput: {
        padding: theme.spacing(1.5, 1.5, 1.5, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create("width"),
        width: "100%",
        [theme.breakpoints.up("md")]: {
            width: "40ch",
        },
    },
}));

export function AssignCoach({ open, onClose, onAssigngingCoach, selectedJobSeeker }) {

    // const classes = useStyles();

    const { user } = useSelector(({ auth }) => auth, shallowEqual);
    const [search, setSearch] = React.useState('')
    const [coachList, setCoachList] = React.useState([])
    const [selectedUser, setSelectedUser] = React.useState('')

    const [coach, setCoach] = React.useState()
    const [loading, setLoading] = React.useState(false)


    const fetchSelectedCoach = async () => {
        if (!selectedJobSeeker || !selectedJobSeeker.invitedBy) return
        setLoading(true)
        console.log("user-=-=", selectedJobSeeker)
        let data = await FetchJobSeekerCoach(selectedJobSeeker.invitedBy)
        setCoach(data.user)
        setLoading(false)
    }

    const onChangeSearch = (value) => {
        setSearch(value)
        fetchCoach(value)
    }

    const onSeltectUser = (value) => {
        setSelectedUser(value._id)
    }

    const fetchCoach = async (s) => {
        let data = await FetchCoachSearchList(s, user.organization)
        setCoachList([...data.users])
    }

    React.useEffect(() => {
        fetchCoach(search)
        fetchSelectedCoach()
    }, [])

    const onSubmit = () => {
        onAssigngingCoach({ jobseekerId: selectedJobSeeker.id, coachId: selectedUser })
    }

    const onDeleteCoach = () => {
        setCoach(undefined)
        setSearch('')
        onAssigngingCoach({ jobseekerId: selectedJobSeeker.id, coachId: '' })
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="form-dialog-title"
            maxWidth="sm"
            fullWidth="100%"
        >
            <DialogTitle id="form-dialog-title">
                <Typography variant="h6">{selectedJobSeeker.invitedBy ? "Update Coach" : 'Assign Coach'}</Typography>
            </DialogTitle>
            <DialogContent>

                {coach && <Grid item>
                    <Typography variant="h6"> Coach Name:   {coach.firstName}
                        <DeleteIcon onClick={() => onDeleteCoach()} />
                    </Typography>
                </Grid>}
                <Grid item>
                    {/* <div className={classes.search}>
                        <div className={classes.searchIcon}>
                            <SearchIcon />
                        </div>
                        <InputBase
                            placeholder="Search client by name, email and phone"
                            classes={{
                                root: classes.inputRoot,
                                input: classes.inputInput,
                            }}
                            inputProps={{ "aria-label": "search" }}
                            onChange={search}
                            onChange={onChangeSearch}
                        />
                    </div> */}

                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={coachList}
                        getOptionLabel={(option) => `${option.firstName.toString()} ${option.lastName.toString()}`}
                        onChange={(evt, newV) => onSeltectUser(newV)}
                        sx={{ width: 300 }}
                        inputValue={search}
                        onInputChange={(event, newInputValue) => onChangeSearch(newInputValue)}
                        renderInput={(params) => <TextField {...params} label="Coach Name" />}
                    />
                </Grid>
            </DialogContent>

            <DialogActions>
                <Grid
                    className="px-5 mb-4"
                    container
                    direction="row"
                    justify="space-between"
                >
                    <Grid item>
                        <Button
                            size="large"
                            onClick={onClose}
                            variant={"contained"}
                        >
                            Cancel
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            size="large"
                            onClick={onSubmit}
                            color="secondary"
                            variant={"contained"}
                            className="px-10"

                        >

                            <Typography>Assign</Typography>

                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}